import {
  getPartner,
  updatePartner,
  resetPartnerMessage,
  enrolePatientShare
} from "store/partners/actions";
import { useDispatch } from "react-redux";

const PartnerApiHook = () => {
  let dispatch = useDispatch();
  const pageInit = () => {
    dispatch(getPartner());
  };
  const getListPartner = (data) => {
    dispatch(getPartner(data));
  };
  const apiUpdatePartner = (data) => {
    dispatch(updatePartner(data));
  };
  const resetMessage = () => {
    dispatch(resetPartnerMessage());
  };
  const enroleUserShare = (data) => {
    dispatch(enrolePatientShare(data));
  };
  return {
    pageInit,
    getListPartner,
    apiUpdatePartner,
    resetMessage,
    enroleUserShare,
  };
};
export default PartnerApiHook;
